import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    question: "What is Click Colony?",
    answer:
      "Click Colony is a secure financial platform that allows you to manage your balance, request withdrawals, and keep track of all your financial activities in one place.",
  },
  {
    question: "How do I create an account?",
    answer:
      "Click the Register button and fill in your details. Your account will need to be approved by an admin before you can log in. This verification step ensures the security of all our users.",
  },
  {
    question: "How long does account approval take?",
    answer:
      "Account approval is handled manually by our admin team. Typically, accounts are reviewed within 24 hours of registration.",
  },
  {
    question: "How do I withdraw funds?",
    answer:
      "Once logged in, go to your Dashboard and click the 'Withdraw' button. Enter the amount you wish to withdraw and confirm. The withdrawal is processed immediately and deducted from your balance.",
  },
  {
    question: "Is my money safe?",
    answer:
      "Yes. All accounts are admin-verified, and every transaction is logged. We use industry-standard security practices including encrypted passwords and secure authentication tokens.",
  },
  {
    question: "How do I update my profile?",
    answer:
      "Navigate to Settings from your user menu. You can update your name, email, and password from there.",
  },
  {
    question: "What if I forget my password?",
    answer:
      "Please contact our support team through the Contact page, and we'll help you reset your password.",
  },
  {
    question: "How do I contact support?",
    answer:
      "Visit the Contact page and fill out the form with your inquiry. Our team will get back to you as soon as possible.",
  },
];

export default function FAQPage() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-8 md:py-16 animate-fade-in" data-testid="faq-page">
      <div className="mb-12">
        <p className="text-xs font-medium tracking-widest uppercase text-emerald-600 mb-3 animate-fade-in-up stagger-1">Support</p>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight mb-4 animate-fade-in-up stagger-2" data-testid="faq-title">
          Frequently Asked Questions
        </h1>
        <p className="text-base text-muted-foreground max-w-xl animate-fade-in-up stagger-3">
          Find answers to common questions about Click Colony. Can't find what you're looking for?
          Visit our contact page.
        </p>
      </div>

      <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
        {faqs.map((faq, i) => (
          <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}>
            <AccordionTrigger className="text-left font-medium text-base hover:no-underline">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground leading-relaxed">
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
